import { render, staticRenderFns } from "./ImageWithSpots.vue?vue&type=template&id=ea67ab8a&scoped=true&"
import script from "./ImageWithSpots.vue?vue&type=script&lang=js&"
export * from "./ImageWithSpots.vue?vue&type=script&lang=js&"
import style0 from "./ImageWithSpots.vue?vue&type=style&index=0&id=ea67ab8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea67ab8a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VDialog,VIcon,VImg,VProgressCircular,VRow,VTooltip})
